<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-forgot"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                <img src="@/assets/images/pages/lock-screen.png" alt="forgot-password" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 forgot-tabs-container">

                <div class="vx-card__title mb-3">
                  <h4 class="mb-4">Crie sua nova senha</h4>
                  <p>Olá, novamente! Nesse espaço você pode criar uma nova senha para seu usuário.</p>
                </div>

                <vs-tabs>
                    <vs-tab label="Admin">

                      <div class="w-full mb-6">
                        <div class="flex items-center">

                          <vs-input
                            ref="password"
                            :type="showPassword ? 'text' : 'password'"
                            data-vv-validate-on="blur"
                            v-validate="'required|min:6'"
                            name="password"
                            label-placeholder="Senha"
                            placeholder="Senha"
                            icon-no-border
                            icon="icon icon-lock"
                            icon-pack="feather"
                            v-model="password"
                            @input="updatePasswordStrength"
                            class="w-full mt-6" />

                            <span>
                              <vs-icon
                              :icon="showPassword ? 'visibility_off' : 'visibility'"
                              class="absolute icon-grow"
                              style="right:.9em; font-size:23px; cursor:pointer; user-select:none;"
                              @click="showPassword = !showPassword"
                              />
                            </span>
                        </div>
                          
                        <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                        
                        <vs-input
                          :type="showPassword ? 'text' : 'password'"
                          v-validate="'required|min:6|confirmed:password'"
                          data-vv-validate-on="blur"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          data-vv-as="password"
                          name="confirm_password"
                          label-placeholder="Confirme a Senha"
                          placeholder="Confirme a Senha"
                          v-model="confirm_password"
                          class="w-full mt-6" />
                        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
                        <password-strong :password="password"></password-strong>
                      </div>

                      <div class="pt-5 flex flex-wrap justify-between my-5">
                        <vs-button 
                          class="w-full" 
                          @click="check"
                          :disabled="!validateForm"
                        >
                          Salvar
                        </vs-button>

                        <div class="mt-5 w-full">
                          <a 
                            class="cursor-pointer text-inherit md:w-auto hover:text-primary"
                            @click="redirectToLogin" 
                          >
                            Voltar ao Login
                          </a>

                          <a 
                            class="float-right cursor-pointer text-inherit md:w-auto hover:text-primary"
                            @click="redirectToForgot" 
                          >
                            Solicitar novo Email
                          </a>
                        </div>
                      </div>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

import userForgot from '@/http/requests/userForgot'
import { getBaseUrl, getCurrentRoute, filterPassword } from '@/utils'
import PasswordStrong from "@/components/password-strong/password-strong.vue"

export default {
  components: {
    PasswordStrong
  },
    data() {
      return {
        password: '',
        confirm_password: '',
        showPassword: false
      }
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.password != '' && this.confirm_password != '';
      },
      baseUrl() {
        return `${getBaseUrl()}`
      },
      currentToken(){
        return getCurrentRoute().replace('/forgot/', '')
      }
    },
    methods: {
      redirectToLogin() {
        this.$router.push({ name: 'login' })
      },
      redirectToForgot() {
        this.$router.push({ name: 'forgot-password' })
      },
      check(){
        userForgot.check({token: this.currentToken, password: this.password})
          .then(() => {
            const passwordStrength = filterPassword(this.password);
          if (passwordStrength <= 75) {
            return this.$vs.notify({
              color: 'danger',
              title: 'Senha inválida',
              text: 'A senha precisa ser forte para que a redefinição seja realizada'
            });
          }
            this.success()
            this.redirectToLogin()
          })
          .catch((error) => {
            console.log(error)
          })
      },
      success() {
        localStorage.removeItem("email");
        localStorage.removeItem("expiration");
        this.$vs.notify({
          time: 7000,
          color: 'success',
          title: 'Esquecimento de Senha',
          text: `A senha foi redefinida com sucesso, você já pode utiliza-la.`
        })
      },
    },
}
</script>

<style lang="scss">
.forgot-tabs-container {
    min-height: 505px;

    .con-tab {
        padding-bottom: 14px;
    }

    .con-slot-tabs {
        margin-top: 1rem;
    }
}
.green {
  color:  #46c93a;
}

.red {
  color: #ff4757;
}
.warning {
  display: flex;
  align-items: center;
  background-color: #fff7d0;
  color: #b29400;
  padding: 15px;
  border-radius: 6px;
  border: 2px solid #b29400;
  margin-top: 10px;
}

.warning .icon {
  margin-right: 20px;
  font-size: 24px;
}

.warning h4 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #b29400;
}

.warning p {
  font-size: 14px;
  line-height: 1.4;
}
.font-bold{
  font-weight: bold;
}

.icon-grow {
  transition: transform 0.3s ease;
}

.icon-grow:hover {
  transform: scale(1.2);
}
</style>

